import { isMockMode, post, simulateDelay } from "../api";

export const getOrgAvatar = ({ orgId }: { orgId: string }) => {
	if (isMockMode()) {
		const testData = {
			avatar_Base64: "",
		};

		return simulateDelay(50, () => testData);
	}

	return post(`Orgs/GetAvatar`, { orgId });
};
